var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarketingLearAcquisi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 40,
    viewBox: "0 0 43 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14117",
    "data-name": "Group 14117",
    transform: "translate(-1248 -4053)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14112",
    "data-name": "Group 14112",
    transform: "translate(-29 -1368)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_375",
    "data-name": "Rectangle 375",
    width: 43,
    height: 40,
    rx: 12,
    transform: "translate(1277 5421)",
    fill: "#3488eb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "marketing-svgrepo-com",
    d: "M19.139,2.169a1.679,1.679,0,0,0-1.571-.134L9.281,5.3a1.639,1.639,0,0,1-.618.121H3.358A1.679,1.679,0,0,0,1.679,7.1v.134H0v4.029H1.679v.175a1.679,1.679,0,0,0,1.679,1.639l2.015,4.271a1.692,1.692,0,0,0,1.518.967h.846A1.679,1.679,0,0,0,9.4,16.634v-3.4L17.568,16.5a1.706,1.706,0,0,0,.631.121,1.733,1.733,0,0,0,.94-.3,1.679,1.679,0,0,0,.739-1.343V3.552A1.679,1.679,0,0,0,19.139,2.169ZM7.723,7.1v4.338H3.358V7.1Zm0,9.536H6.877L5.225,13.075h2.5Zm2.176-5a3.076,3.076,0,0,0-.5-.2V7a3.035,3.035,0,0,0,.5-.148l8.3-3.3v11.39Zm10.02-4.07v3.358a1.679,1.679,0,1,0,0-3.358Z",
    transform: "translate(1259 4063.098)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingLearAcquisi);
export default __webpack_public_path__ + "static/media/marketing-lear-acquisi.01e81c78b81f87366693000fc4417ba1.svg";
export { ForwardRef as ReactComponent };